"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var button_config_1 = require("../../../model/button-config");
require("rxjs/add/operator/takeUntil");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var selected_main_entity_info_1 = require("../../../model/selected-main-entity-info");
var TableButtonConfigComponent = /** @class */ (function () {
    function TableButtonConfigComponent(classifierService) {
        this.classifierService = classifierService;
        this.configsChanged = new core_1.EventEmitter();
    }
    TableButtonConfigComponent_1 = TableButtonConfigComponent;
    TableButtonConfigComponent.getEmptyButton = function (selectedMainEntity, defaultButtonTitle, useSameSearchSettings, defaultButtonConfig) {
        return new button_config_1.ButtonConfig(defaultButtonTitle, [], { lookupFieldSystemName: null, lookupFieldCompoundName: null, lookupFieldValue: null }, { defaultValueFieldSystemName: null, defaultValueFieldCompoundName: null, defaultValueFieldValue: null }, useSameSearchSettings && defaultButtonConfig ? defaultButtonConfig.searchKeywords : [], useSameSearchSettings && defaultButtonConfig ? defaultButtonConfig.filterFields : [], useSameSearchSettings && defaultButtonConfig ? defaultButtonConfig.columns : [], selectedMainEntity.nameMetaFieldIds || [], useSameSearchSettings && defaultButtonConfig ? defaultButtonConfig.subFormId : null, useSameSearchSettings && defaultButtonConfig ? defaultButtonConfig.hasCreateButton : null);
    };
    TableButtonConfigComponent.prototype.addNewOption = function () {
        this.buttonConfigs.push(TableButtonConfigComponent_1.getEmptyButton(this.selectedMainEntity, this.defaultButtonTitle));
        this.configsChanged.emit(true);
    };
    TableButtonConfigComponent.prototype.deleteOption = function (index) {
        this.buttonConfigs.splice(index, 1);
        this.configsChanged.emit(true);
    };
    TableButtonConfigComponent.prototype.onSearchFilterFieldSelect = function (lookupFieldSystemName, buttonConfig) {
        var _this = this;
        if (lookupFieldSystemName && buttonConfig.searchFilter.lookupFieldSystemName !== lookupFieldSystemName) {
            buttonConfig.searchFilter.lookupFieldValue = null;
            var lookupField_1 = this.selectedMainEntity.lookupFields.find(function (field) { return field.getSystemName() === lookupFieldSystemName; });
            buttonConfig.searchFilter.lookupFieldSystemName = lookupFieldSystemName;
            buttonConfig.searchFilter.lookupFieldCompoundName = lookupField_1.getCompoundCategorySystemName();
            this.classifierService.loadAllClassifiers(lookupField_1.getCompoundCategorySystemName())
                .map(function (classifierResponse) { return classifierResponse.getData(); })
                .subscribe(function (classifiers) { return _this.classifierCache.set(lookupField_1.getCompoundCategorySystemName(), classifiers); });
        }
        else if (!lookupFieldSystemName) {
            buttonConfig.searchFilter.lookupFieldValue = null;
            buttonConfig.searchFilter.lookupFieldSystemName = null;
            buttonConfig.searchFilter.lookupFieldCompoundName = null;
        }
        this.configsChanged.emit(true);
    };
    TableButtonConfigComponent.prototype.onDefaultValueFieldSelect = function (defaultValueFieldSystemName, buttonConfig) {
        var _this = this;
        if (defaultValueFieldSystemName && buttonConfig.defaultValues.defaultValueFieldSystemName !== defaultValueFieldSystemName) {
            buttonConfig.defaultValues.defaultValueFieldValue = null;
            var defaultField_1 = this.selectedSubEntityLookupMetaFields.find(function (field) { return field.getSystemName() === defaultValueFieldSystemName; });
            buttonConfig.defaultValues.defaultValueFieldSystemName = defaultValueFieldSystemName;
            buttonConfig.defaultValues.defaultValueFieldCompoundName = defaultField_1.getCompoundCategorySystemName();
            this.classifierService.loadAllClassifiers(defaultField_1.getCompoundCategorySystemName())
                .map(function (classifierResponse) { return classifierResponse.getData(); })
                .subscribe(function (classifiers) { return _this.classifierCache.set(defaultField_1.getCompoundCategorySystemName(), classifiers); });
        }
        else if (!defaultValueFieldSystemName) {
            buttonConfig.defaultValues.defaultValueFieldValue = null;
            buttonConfig.defaultValues.defaultValueFieldSystemName = null;
            buttonConfig.defaultValues.defaultValueFieldCompoundName = null;
        }
        this.configsChanged.emit(true);
    };
    TableButtonConfigComponent.prototype.onSearchFilterValueSelect = function (classifierId, buttonConfig) {
        buttonConfig.searchFilter.lookupFieldValue = classifierId;
        this.configsChanged.emit(true);
    };
    TableButtonConfigComponent.prototype.onDefaultFieldValueSelect = function (classifierId, buttonConfig) {
        buttonConfig.defaultValues.defaultValueFieldValue = classifierId;
        this.configsChanged.emit(true);
    };
    var TableButtonConfigComponent_1;
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], TableButtonConfigComponent.prototype, "buttonConfigs", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Map)
    ], TableButtonConfigComponent.prototype, "classifierCache", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], TableButtonConfigComponent.prototype, "languages", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", selected_main_entity_info_1.SelectedMainEntityInfo)
    ], TableButtonConfigComponent.prototype, "selectedMainEntity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], TableButtonConfigComponent.prototype, "selectedSubEntityLookupMetaFields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_crosscutting_concepts_frontend_1.MultilingualString)
    ], TableButtonConfigComponent.prototype, "defaultButtonTitle", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], TableButtonConfigComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], TableButtonConfigComponent.prototype, "configsChanged", void 0);
    TableButtonConfigComponent = TableButtonConfigComponent_1 = __decorate([
        core_1.Component({
            selector: 'ejustice-table-button-config',
            styles: [require('./table-button-config.component.css')],
            template: require('./table-button-config.component.html')
        }),
        __metadata("design:paramtypes", [idm_classifier_service_client_js_1.ClassifierService])
    ], TableButtonConfigComponent);
    return TableButtonConfigComponent;
}());
exports.TableButtonConfigComponent = TableButtonConfigComponent;
//# sourceMappingURL=table-button-config.component.js.map